import { ChangeEvent, useEffect } from 'react';
import IntlPhoneField from 'react-intl-tel-input';
import classnames from 'classnames';
import { useFormikContext } from 'formik';

import '../react-intl-tel-input-styles/main.css';
import './styles/phone.scss';

type PhoneFieldProps = {
  className?: string,
  hasError?: boolean
  id: string
  name?: string,
  onChange: (e: ChangeEvent<HTMLInputElement>) => void,
  value?: string | undefined
}

const PhoneField =   ({ 
  className,
  hasError,
  name,
  id,
  ...rest
}:PhoneFieldProps) => { 

  const formikProps = useFormikContext();

  useEffect(() => {
    const flagDropdown = document.querySelector('.selected-flag');
    if (flagDropdown) flagDropdown.addEventListener('click', onFlagDropdownClick);
  }, []);

  function onFlagDropdownClick(e) {
    e.preventDefault();
  }

  function handlePhoneChange(valid, value) {
    formikProps.setFieldValue(id, value);
    return value.replace(/(\s|-)/g, '');
  }

  return (
    <IntlPhoneField
      fieldId={ id ?? 'phone' }
      fieldName={ name ?? 'phone' }
      aria-placeholder="Please enter your phone number"
      aria-required
      allowDropdown
      defaultCountry="us"
      useMobileFullscreenDropdown
      onPhoneNumberBlur={ () => {
        formikProps.setFieldTouched('phone', true);
      } }
      onPhoneNumberChange={ (valid, value) => handlePhoneChange(valid, value) }       
      inputClassName={ classnames('form-field--phone', 'input', 'form-field--input', { 'input-has-error': !!hasError }, className) }
      { ...rest }
    />
  );

  
};

export default PhoneField;